import type { ColumnDef } from "@tanstack/react-table";
import { Button } from "../../components/button";
import { useNavigate } from "react-router-dom";
import React from "react";

type ProductMaster = {
  id: string;
  customer: string;
  no_of_variants: string;
  design: string;
  date: string;
  mainCategory: string;
};

type ColumnOptions = {
  onDelete: (id: string) => void;
  onShow: (id: string) => void;
};

export const ProductMasterColumns = ({ onDelete, onShow }: ColumnOptions): ColumnDef<ProductMaster>[] => {
  const navigate = useNavigate();

  return [
    {
      accessorKey: "customer",
      header: "Customer",
      cell: ({ row }) => row.original.customer,
    },
    {
      accessorKey: "no_of_variants",
      header: "No of Variants",
      cell: ({ row }) => row.original.no_of_variants,
    },
    {
      accessorKey: "design",
      header: "Design",
      cell: ({ row }) => row.original.design,
    },
    {
      accessorKey: "date",
      header: "Date",
      cell: ({ row }) => row.original.date,
    },
    {
      accessorKey: "mainCategory",
      header: "Main Category",
      cell: ({ row }) => row.original.mainCategory,
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const id = row.original.id;
        return (
          <div className="flex gap-2">
            <Button onClick={() => onShow(id)}>Variant</Button>
            <Button onClick={() => navigate(`/product-master/edit/${id}`)}>Edit</Button>
            <Button variant="destructive" onClick={() => onDelete(id)}>
              Delete
            </Button>
          </div>
        );
      },
    },
  ];
};